export default __webpack_public_path__ + "static/media/risk-bars-low-dark.07dd1dc8.svg";